import { useEffect, useRef, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { saveRecord, stt, tts } from "../../api/clova";
import styled from "styled-components";
// @ts-ignore
import recording from "../imgs/record_pc.png";
// @ts-ignore
import mic from "../imgs/mic.png";

const CLOVASpeech = ({
  recordMsg,
  setRecordMsg,
  ttsData,
  setIsResetList,
  titls,
  detail,
  google,
  isAvatar,
  isDisabledBtn,
  trip,
  mode,
  stop,
}: {
  recordMsg: string;
  setRecordMsg: any;
  ttsData: any;
  setIsResetList: any;
  titls: string;
  detail: string;
  google?: string;
  trip?: string;
  isAvatar: boolean;
  isDisabledBtn: boolean;
  mode: string;
  stop: boolean;
}) => {
  const [onRec, setOnRec] = useState(true);
  const [audioUrl, setAudioUrl] = useState<Blob | null>(null);
  const [fileSet, setFileSet] = useState<File | null>(null);
  const [audioFile, setAudioFile] = useState();
  const [noResult, setNoResult] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const mediaRef = useRef<MediaRecorder | null>(null);
  const streamRef = useRef<MediaStream | null>(null);
  const audioRef = useRef<HTMLAudioElement>(null);
  const profile = localStorage.getItem("profile");
  // const [playBtn, setPlayBtn] = useState("stop");
  const [hiddenMic, setHiddenMic] = useState(false);

  const onHiddenMic = () => {
    setHiddenMic(true);
  };

  const { mutate: makeSpeech } = useMutation({
    mutationFn: (data) => tts(data),
    onSuccess: (data) => {
      setAudioFile(data.data.data);
      if (audioFile) {
        handlePlayAudio();
      }
    },
    onError: (error) => {
      console.log("TTS 오류:", error);
    },
  });

  useEffect(() => {
    if (mode !== "") {
      handlePlayAudio();
    }
  }, [mode]);

  useEffect(() => {
    handlePlayAudio();
  }, [audioFile]);

  useEffect(() => {
    if (ttsData) {
      //@ts-ignore
      makeSpeech({ speaker: profile || "vdaeseong", text: ttsData.join("") });
    }
  }, [ttsData]);

  const handlePlayAudio = () => {
    if (mode !== "" && audioRef.current) {
      audioRef.current.play().catch((error) => {
        console.log("Audio play error:", error);
      });
      setIsPlaying(true);
    }
  };

  useEffect(() => {
    if (mode === "") {
      stopAudio();
    }
  }, [mode]);

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    setIsPlaying(false);
  };

  useEffect(() => {
    if (stop) {
      setRecordMsg("");
      setAudioFile(ttsData);
    }
  }, [stop]);

  const handleAudioEnd = async () => {
    stopAudio();
    onHiddenMic();
    if (recordMsg) {
      return;
    }

    setIsPlaying(false);
    setIsRecording(true);
    await onRecAudio();
    setTimeout(() => {
      offRecAudio();
    }, 3000);
  };

  const onRecAudio = async () => {
    try {
      if (!streamRef.current) {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        streamRef.current = stream;
      }
      const mediaRecorder = new MediaRecorder(streamRef.current);

      mediaRecorder.start();
      mediaRef.current = mediaRecorder;
      setOnRec(false);
    } catch (error) {
      console.error("오디오 녹음 시작 실패:", error);
    }
  };

  const offRecAudio = () => {
    if (mediaRef.current && streamRef.current) {
      mediaRef.current.ondataavailable = (e) => setAudioUrl(e.data);
      streamRef.current.getAudioTracks().forEach((track) => track.stop());
      mediaRef.current.stop();
      setOnRec(true);
    }
  };

  useEffect(() => {
    if (audioUrl) {
      onSubmitAudioFile();
    }
  }, [audioUrl]);

  useEffect(() => {
    if (mode !== "") {
      handlePlayAudio();
    }
  }, [mode]);

  const onSubmitAudioFile = () => {
    if (!audioUrl) return;
    setIsResetList(false);

    const sound = new File([audioUrl], "test.wav", {
      lastModified: new Date().getTime(),
      type: "audio/wav",
    });
    setFileSet(sound);
    setIsRecording(false);
  };

  const { mutate: saveFile } = useMutation({
    mutationFn: (data) => saveRecord(data),
    onSuccess: (data) => {
      //@ts-ignore
      mutate({
        url: data.data.data,
        language: "ko-KR",
        completion: "sync",
      });
    },
    onError: (error) => {
      console.log("파일 저장 오류:", error);
    },
  });

  useEffect(() => {
    if (fileSet) {
      const formData = new FormData();
      formData.append("file", fileSet);
      //@ts-ignore
      saveFile(formData);
    }
  }, [fileSet, saveFile]);

  const { mutate } = useMutation({
    mutationFn: (data) => stt(data),
    onSuccess: (data) => {
      if (data.data.text === "") {
        setNoResult(true);
      }
      setRecordMsg(data.data.text);
    },
    onError: (error) => {
      console.log("STT 오류:", error);
    },
  });

  useEffect(() => {
    if (trip) {
      //@ts-ignore
      makeSpeech({ speaker: profile || "vdaeseong", text: trip });
    }
  }, [trip]);

  useEffect(() => {
    if (google) {
      //@ts-ignore
      makeSpeech({ speaker: profile || "vdaeseong", text: google });
    }
  }, [google]);

  useEffect(() => {
    if (detail) {
      //@ts-ignore
      makeSpeech({ speaker: profile || "vdaeseong", text: detail });
    }
  }, [detail]);

  useEffect(() => {
    if (titls) {
      //@ts-ignore
      makeSpeech({ speaker: profile || "vdaeseong", text: titls });
    }
  }, [titls]);

  const handleAudioEnded = () => {
    setIsPlaying(false);
  };

  return (
    <Wrapper>
      {!hiddenMic && (
        <img src={mic} width={72} height={37} alt="" onClick={handleAudioEnd} />
      )}

      <div>
        <audio
          id="myAudio"
          ref={audioRef}
          src={audioFile}
          onEnded={handleAudioEnded}
        />
        {noResult ? (
          <div>음성이 인식되지 않았습니다.</div>
        ) : (
          <>
            {isRecording ? (
              <ImgWrap>
                {<img src={recording} alt="" width={122} height={18} />}
              </ImgWrap>
            ) : null}
          </>
        )}
      </div>
    </Wrapper>
  );
};

export default CLOVASpeech;

const Wrapper = styled.div`
  > img {
    width: fit-content;
    margin-top: 50px;
  }
`;

// const PlayButton = styled.button`
//   background-color: #e4e4e4;
//   border: none;
//   border-radius: 50px;
//   padding: 5px 20px;
//   font-size: 12px;
//   cursor: pointer;
//   transition: background-color 0.3s;
// `;

const ImgWrap = styled.div`
  background-color: white;
  border-radius: 79px;
  width: 240px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;

  > img {
    width: 180px;
    height: 100%;
    object-fit: contain;
  }
`;
